export type AvatarEmote = "dance" | "wave";
export type AvatarAnimationCategory = "loop" | "gesture";

const EMOTE_CATEGORY: Record<AvatarEmote, AvatarAnimationCategory> = {
  dance: "loop",
  wave: "gesture",
};

const SITTING_ALLOWED_CATEGORIES = new Set<AvatarAnimationCategory>([
  "gesture",
]);

export function animationCategoryForEmote(
  emote: AvatarEmote
): AvatarAnimationCategory {
  return EMOTE_CATEGORY[emote];
}

export function canPlayEmoteForAvatarState(
  emote: AvatarEmote,
  isSitting: boolean | undefined
): boolean {
  if (!isSitting) {
    return true;
  }
  return SITTING_ALLOWED_CATEGORIES.has(animationCategoryForEmote(emote));
}
